import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import classNames from 'classnames/bind'

import { localize } from 'helpers/translator'
import FullOverlay from 'views/overlay/full_overlay/FullOverlay'
import Bodymovin from 'components/bodymovin/bodymovin'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import adminOnboardingActions from 'redux/actions/adminOnboardingActions'
import Ellipsis from 'components/ellipsis/ellipsis'
import adminOnboardingPremiumActivitiesSelector from 'redux/selectors/admin_onboarding/admin_onboarding_premium_activities_selector'

import styles from '../PremiumActivitiesNotification.scss'
import icon from 'assets/views/admin_onboarding/clock.svg'

const cx = classNames.bind(styles)

class PremiumActivitiesAddLesson extends PureComponent {

	createTitle = () => {
		if (this.props.premiumActivitiesAddLessonStep === 2)
			return (
				<span>
					{localize('admin_onboarding_premium_activities_add_lesson_title_success_part1')} <br />
					<strong className={cx({ strong: true })}>{localize('admin_onboarding_premium_activities_add_lesson_title_success_part2')}</strong>
				</span>
			)

		return (
			<span>
				<strong className={cx({ strong: true })}>{localize('admin_onboarding_premium_activities_add_lesson_title_part1')}</strong>
				{localize('admin_onboarding_premium_activities_add_lesson_title_part2')} <br />
				{localize('admin_onboarding_premium_activities_add_lesson_title_part3')}
			</span>
		)
	}

	createAsset() {
		return (
			<Bodymovin
				path='/assets/media/animations/lesson-icon.json'
				loop={true}
			>
				<div style={{
					width: '100%',
					height: '100%',
				}}></div>
			</Bodymovin>
		)
	}

	createPrimaryTextButton = () => {
		switch (this.props.premiumActivitiesAddLessonStep) {
			case 1:
				return (
					<span>
						{localize('admin_onboarding_premium_activities_primary_text_button_loading')}
						<Ellipsis />
					</span>
				)
			case 2:
				return localize('admin_onboarding_premium_activities_primary_text_button_library')
			default:
				return localize('admin_onboarding_premium_activities_primary_text_button')
		}
	}

	createSecundaryTextButton = () => this.props.premiumActivitiesAddLessonStep === 0 ? localize('admin_onboarding_premium_activities_secondary_text_button') : ''

	addLessonHander = () => {
		if (this.props.premiumActivitiesAddLessonStep === 0)
			return this.props.actions.addLesson
		if (this.props.premiumActivitiesAddLessonStep === 2)
			return this.props.actions.showMyLibrary
	}

	render() {

		return (
			<FullOverlay
				shouldShowAnimation={false}
				notificationIcon={icon}
				notificationText={this.props.offerTitle}
				title={this.createTitle()}
				assetSource={this.createAsset()}
				assetWidth='368px'
				assetHeight='270px'
				minHeight='660px'
				primaryTextButton={this.createPrimaryTextButton()}
				primaryActionHandler={this.addLessonHander()}
				secondaryTextButton={this.createSecundaryTextButton()}
				secondaryActionHandler={this.props.actions.gotToMyLibrary}
			/>
		)
	}
}

function mapStateToProps(state) {
	return adminOnboardingPremiumActivitiesSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		addLesson: adminOnboardingActions.premiumActivitiesAddLesson,
		gotToMyLibrary: adminOnboardingActions.premiumActivitiesGoToMyLibrary,
		showMyLibrary: adminOnboardingActions.premiumActivitiesShowMyLibrary,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PremiumActivitiesAddLesson)
